import {SET_INTERACTION_DATA,SET_ACTIVITY_INTERACTION_DATA,SET_SELECTED_INTERACTION_DATA, GET_SHOP_SITE_DATA, GET_BRAND_SHOPIFY,SET_SHOPIFY_ALL_DATA,SET_SHOP_COM_ALL_DATA, GET_PRODUCT_DETAILS, GET_PRODUCT_DETAIL,GET_PRODUCTS_IN_CART, CLEAR_PRODUCT_DATA, SET_PRODUCT_DETAILS_LOADING} from './interaction.actiontypes'


const initialState = {
    interactionData: [],
    activityInteractionData:[],
    selectedInteraction:{},
    shopSiteName: "",
    productDetails:[],
    productDetail: {},
    brandShopifyData:[],
    shopifyAllData:[],
    shopComAllData:[],
    productsInCart: [],
    productDetailsLoading: false,
}



export default function interactionmain(state = initialState, action: any) {
    
    switch (action.type) {
        case SET_INTERACTION_DATA:{
            return {
                ...state,
                interactionData:action.payload
            };
        }
        case GET_PRODUCT_DETAILS:{
            return {
                ...state,
                productDetails:action.payload
            };
        }
        case GET_PRODUCT_DETAIL:{
            return {
                ...state,
                productDetail:action.payload
            };
        }
        case SET_ACTIVITY_INTERACTION_DATA:{
            return {
                ...state,
                activityInteractionData:action.payload
            };
        }
        case SET_SELECTED_INTERACTION_DATA:{
            return {
                ...state,
                selectedInteraction:action.payload
            };
        }
        case GET_SHOP_SITE_DATA:{
            return {
                ...state,
                shopSiteName:action.payload
            };
        }
        case GET_BRAND_SHOPIFY:{
            return {
                ...state,
                brandShopifyData:action.payload
            };
        }
        case SET_SHOPIFY_ALL_DATA:{
            return {
                ...state,
                shopifyAllData:action.payload
            };
        }
        case SET_SHOP_COM_ALL_DATA:{
            return {
                ...state,
                shopComAllData:action.payload
            };
        }
        case GET_PRODUCTS_IN_CART:{
            return {
                ...state,
                productsInCart:action.payload
            };
        }

        case CLEAR_PRODUCT_DATA:{
            return {
                ...state,
                productDetails: [],
                productDetail: {},
                productsInCart: [],
                shopifyAllData: [],
                shopComAllData: [],
                brandShopifyData: [],
                interactionData: []
            };
        }
        case SET_PRODUCT_DETAILS_LOADING:{
            return {
                ...state,
                productDetailsLoading: action.payload
            };
        }
        default:
        return state;

    }

}